
import style from './style.module.css';

const HomeCard = props => (
    <div className={style.HomeCard} onClick={() => props.onSelect && props.onSelect()}>
        <div className={style.info}>
            {/* <div className={style.icon} style={{ backgroundImage: `var(--appearance-${props.icon || ''})` }} /> */}
            <div className={style.title + ' home-text-secondary'}>{props.title || ''}</div>
            {props.onSelect ? <div className={style.arrow} /> : null}
        </div>
        <div className={style.content}>
            {props.children}
        </div>
    </div>
);

export default HomeCard;
